import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FavoritosService } from './../../services/favoritos.service';

@Component({
  selector: 'app-material-list',
  templateUrl: './material-list.component.html',
  styleUrls: ['./material-list.component.scss']
})
export class MaterialListComponent implements OnInit {
  @Input() item;
  @Input() favList;
  @Output() addFavList: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeFavList: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _favoritos: FavoritosService) { }

  ngOnInit() { }

  addFav() {
    this._favoritos.addFav(this.item).subscribe();
  }

  removeFav() {
    this._favoritos.removeFav(this.item).subscribe();
  }

}
